module.exports = __webpack_public_path__ + "8789d0484d864d5f4d446734515f475e.svg";